/* Sportmerch Fix: client-seitiger Variantenwechsel fuer die Section
   'Vorgestelltes Produkt' auf eigenen Seiten (/pages/...).

   Hintergrund: Dawns Varianten-Picker rendert die Section per
   Section-Rendering-API ueber die PRODUKT-URL neu. Auf einer
   Nicht-Produktseite kommt das HTML ohne Picker zurueck -> der Picker
   verschwindet und der Button wird "nicht verfuegbar". Dieser Patch
   wechselt die Variante client-seitig (ohne Fetch), wenn die aktuelle
   Seite KEINE /products/-Seite ist. Echte Produktseiten bleiben voellig
   unveraendert (Original-Verhalten). */
(function () {
  function patch() {
    var P = window.customElements && customElements.get('product-info');
    if (!P || P.prototype.__smPatched) return;
    P.prototype.__smPatched = true;
    var origRender = P.prototype.renderProductInfo;
    P.prototype.renderProductInfo = function (args) {
      if (/\/products\//.test(window.location.pathname)) return origRender.call(this, args);
      try { return this.__smUpdate(); }
      catch (e) { console.error('[Sportmerch variant fix]', e); return origRender.call(this, args); }
    };
    P.prototype.__smUpdate = async function () {
      var base = (this.dataset.url || '').split('?')[0];
      var handle = base.split('/products/')[1];
      if (!handle) return;
      if (!this.__smData) {
        this.__smData = await fetch('/products/' + handle + '.js').then(function (r) { return r.json(); });
      }
      var data = this.__smData;
      var chosen = [];
      var fsets = Array.prototype.slice.call(this.querySelectorAll('variant-selects fieldset'));
      if (fsets.length) {
        chosen = fsets.map(function (fs) { var r = fs.querySelector('input:checked'); return r ? r.value : null; });
      } else {
        chosen = Array.prototype.slice.call(this.querySelectorAll('variant-selects select')).map(function (s) { return s.value; });
      }
      var variant = data.variants.find(function (v) {
        return v.options.length === chosen.length && v.options.every(function (o, i) { return o === chosen[i]; });
      });
      // Es koennen mehrere Formulare/IDs vorhanden sein (Dawn + z.B. PageFly).
      // Daher ALLE versteckten id-Felder im product-info aktualisieren, damit
      // egal welches Formular abgeschickt wird, die richtige Variante landet.
      var idInputs = this.querySelectorAll('input[name="id"]');
      function setIds(val) { for (var i = 0; i < idInputs.length; i++) { idInputs[i].value = val; } }
      var pf = this.productForm;
      if (variant && variant.available) {
        setIds(variant.id);
        if (pf) pf.toggleSubmitButton(false);
      } else {
        if (variant) setIds(variant.id);
        var soldOut = (window.variantStrings && (window.variantStrings.soldOut || window.variantStrings.unavailable)) || 'Nicht verfuegbar';
        if (pf) pf.toggleSubmitButton(true, soldOut);
      }
      return variant;
    };
  }
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('product-info').then(patch);
  }
})();
